<template>
  <div>
    <a-drawer :title="`${actType}`" :width="720" :visible="showZmForm" :body-style="{ paddingBottom: '80px' }"
      @close="close">

      <a-form-model ref="form" :model="model" :rules="rules">
        <a-form-model-item label="转码后的目录" prop="pid">
          <a-tree-select v-model="model.pid" style="width: 100%" placeholder="根目录" show-search allow-clear :treeNodeFilterProp="'title'" :tree-data="treeData" 
            :replace-fields="replaceFields" :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" />
        </a-form-model-item>

        <a-form-model-item label="转码后的素材名称" prop="zm_name" help="转码后的素材名称会根据转码素材的数量自动在填写的素材名称后面添加对应的数字，比如：素材名称_1，依次排序；未填写，素材名称则不做任何处理。">
          <a-input v-model="model.zm_name" />
        </a-form-model-item>
      </a-form-model>

      <div :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }">
        <a-button @click="close" :disabled="loading" :style="{ marginRight: '8px' }">
          取消
        </a-button>
        <a-button type="primary" @click="submit" :disabled="loading">确定</a-button>
      </div>


    </a-drawer>
  </div>
</template>

<style lang="less" scoped>
@import 'CreateZm';
</style>

<script>
import CreateZm from './CreateZm'

export default CreateZm
</script>
